module.exports = "/virtual-football-league/img/amblems/left/Italy/Fake_Milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Italy/Fake_Milan.png
// module id = 2042
// module chunks = 4